<template>
  <ul :key="insiders" class="flex flex-wrap">
    <insider-proof-item
      v-for="(ins, idx) in insiders"
      :key="idx"
      :data="ins"
      :index="idx + 1"
    ></insider-proof-item>
  </ul>
</template>

<script setup>
import InsiderProofItem from "@/components/InsiderProofItem.vue";
import { useArchiveStore } from "@/stores/archive";
import { useConfigStore } from "@/stores/config";
import { computed, ref } from "vue";

import ins from "@data/insiders.json";

const archiveStore = useArchiveStore();
const configStore = useConfigStore();

// const insiders = computed(()=> archiveStore.getInsiders)

const insiders = computed(() => {
  const reversed = ins.reverse();

  const filtered = reversed.filter((item) => item.ft === true);

  const sliced = filtered.slice(filtered.length > 9 ? filtered.length - 9 : 0);

  return sliced;
});

// const insiders = computed(() =>
//   ins
//     .reverse()
//     .filter((item) => item.ft === true)
//     .slice(ins.length > 10 ? ins.length - 10 : 0)
// );
</script>
